const baseUrl = "https://torsor.typeform.com/to";

const TypeformUrls = {
  GRADING: `${baseUrl}/K4rFEY`,
  MARKET_ANALYSIS: `${baseUrl}/GdmXlw`,
  COMPETITIVE_ANALYSIS: `${baseUrl}/IBoTy3`,
  KPI: `${baseUrl}/xrWv1Z`,
  PROFITABILITY: `${baseUrl}/iR33sd`,
  INCOME_STATEMENT: `${baseUrl}/iR33sd`,
  MARKET_CAP: `${baseUrl}/A9VqgW`,
  FINANCIAL_METRICS: `${baseUrl}/IA9X0X`,
  IRR: `${baseUrl}/nSXrb2`,
  INVESTOR_DATA: `${baseUrl}/CnDGqv`,
  STOCK_RETURN: `${baseUrl}/CnDGqv`,
  PRODUCT_COSTS: `${baseUrl}/CnDGqv`,
  COST_OF_CAPITAL: `${baseUrl}/bIZtZr`,
  DIVIDEND_YIELD: `${baseUrl}/b8Bc9v`,
  PRICING: `${baseUrl}/QSDsia`,
  DISCOUNT_RATE: `${baseUrl}/QSDsia`,
  // TODO(austin) fill this in when perceptual map is added
  PERCEPTUAL_MAP: `${baseUrl}/`,
  PRODUCT_AWARENESS: `${baseUrl}/PL0Bl2`,
  MARKETING_FUNNEL: `${baseUrl}/PL0Bl2`,
  FINANCIAL_ANALYSIS: `${baseUrl}/I32NLf`,
  FINANCIAL_PROJECTIONS: `${baseUrl}/MQSxRX`,
  FINANCIALS: `${baseUrl}/qdecks`,
  WORKING_CAPITAL: `${baseUrl}/QMjn4K`,
  INSIGHTS_ROUND_1: `${baseUrl}/QMjn4K`,
  INSIGHTS_ROUND_2: `${baseUrl}/PL0Bl2`,
  INSIGHTS_ROUND_3: `${baseUrl}/IgO7SI`,
  UTILIZATION: `${baseUrl}/XGCjhJ`,
  BUSINESS_VALUATION: `${baseUrl}/HtpMPG`,
  CASH_FLOWS: `${baseUrl}/Kd9bWe`,
  BALANCE_SHEET: `${baseUrl}/GjCzBN`,
  EARNINGS_PER_SHARE: `${baseUrl}/sgcoG7`,
  STOCK_PRICE: `${baseUrl}/EOhRTG`,
  ROIC: `${baseUrl}/Dla8KA`,
  RNOA: `${baseUrl}/KT6MRo`,
  EARNINGS_YIELD: `${baseUrl}/KXG2q9`,
  CAPITAL_BUDGETING: `${baseUrl}/j2WTCP`,
  CAPITAL_STRUCTURE: `${baseUrl}/EBfTba`,
  DEBT_TO_CAPITAL: `${baseUrl}/HmI55z`,
  EQUITY_OFFERING: `${baseUrl}/Oub4Pw`,
  DEBT_VS_EQUITY: `${baseUrl}/Oub4Pw`,
  MARKETING_MIX: `${baseUrl}/cwEiGE`,
  PRODUCT_MARKET_FIT: `${baseUrl}/OTctgx`,
  PRODUCT_LIFECYCLE: `${baseUrl}/hB8tb0`,
  TIME_VALUE_OF_MONEY: `${baseUrl}/BcltG5`,
  NPV_ANALYSIS: `${baseUrl}/j2WTCP`,
  SHARES_OUTSTANDING: `${baseUrl}/LA9Aeu`,
  STP: `${baseUrl}/MWFcog`
};

export default TypeformUrls;



// WEBPACK FOOTER //
// ./src/components/typeform/TypeformUrls.js